module.exports = __webpack_public_path__ + "assets/favicon-16x16.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/favicon-16x16.png
// module id = 931
// module chunks = 17